import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home.jsx";
import Address from "../pages/Address.jsx";
import Tx from "../pages/Tx.jsx";
import Wallet from "../pages/Wallet.jsx";
import Block from "../pages/Block.jsx";
import Send from "../pages/Send.jsx";

const Navigations = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/address" element={<Address />} />
                <Route path="/send" element={<Send />} />
                <Route path="/tx/:txhash" element={<Tx />} />
                <Route path="/wallet/:walletAddress" element={<Wallet />} />
                <Route path="/block/:blockNumber" element={<Block />} />
            </Routes>
        </>
    );
};

export default Navigations;
